// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/c599f5974d35aa52296b.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"9cef04d89de493a597cd","140":"d961e5134f4e1034c977","141":"cd1dfa08b28df66be983"}[chunkId] + ".chunk.js";
};